import { ConfigProvider } from 'antd'
import type { NextPage } from 'next'
import React from 'react'

type PropTypes = {
  children: React.ReactNode
}

const ThemeLayout: NextPage<PropTypes> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#B4826E',
          colorLink: '#B4826E',
          colorBgBase: '#fff',
          colorLinkActive: '#B4826E',
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export default ThemeLayout
